const toLogin = "/";
const toPanel = "/panel";
const toRegister = "/register";
const toResult = "/result";
const toInsDay = "/insday";
const toStatment ="/statment/:id";
const toStatmentsList = "/statments";
const toLastInvoice = "/invoice";
const toAllDays = "/alldays";
const toEditDay = "/editday/:id";
const toInvoicesList = "/invoiceslist";
const toArchiwum = "/archiwum";
const toArchInsDay = "/archinsday";
const toArchResult = "/archresult";
const toArchAllDays = "/archalldays";
const toArchEditDay = "/archeditday/:id";
const toArchStatment = "/archstatment/:id";
const toArchStatmentsList = "/archstatments";

export {
  toLogin,
  toPanel,
  toRegister,
  toResult,
  toInsDay,
  toStatment,
  toStatmentsList,
  toLastInvoice,
  toAllDays,
  toEditDay,
  toInvoicesList,
  toArchiwum,
  toArchInsDay,
  toArchResult,
  toArchAllDays,
  toArchEditDay,
  toArchStatment,
  toArchStatmentsList,
};